import { render } from "./Community.view.vue?vue&type=template&id=54ee6dc9"
import script from "./Community.view.vue?vue&type=script&lang=js"
export * from "./Community.view.vue?vue&type=script&lang=js"

import "./Community.view.vue?vue&type=style&index=0&id=54ee6dc9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__